import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...props}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, dark = false }) => (
  <Reveal className="flex items-end gap-5 mb-12" data-testid={`chapter-${number}`}>
    <span className="font-display font-black text-6xl md:text-8xl leading-[0.8] text-[#ED1C27]">{number}</span>
    <div className="pb-1">
      <span className={`block h-px w-14 mb-2.5 ${dark ? "bg-white/30" : "bg-[#003E75]/20"}`} />
      <span className={`text-xs font-semibold uppercase tracking-[0.3em] ${dark ? "text-white/50" : "text-[#003E75]/45"}`}>{label}</span>
    </div>
  </Reveal>
);
